<template>
  <footer>
    <p>
      Made with <i class="fab fa-vuejs"></i> by
      <a href="https://twitter.com/julio_codes">Julio Molina</a>
    </p>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  text-align: center;
  color: aliceblue;
  font-size: 1.5rem;
}
a:link,
:visited {
  text-decoration: none;
  color: aliceblue;
}

a:hover {
  text-decoration: none;
  color: rgba(59, 130, 246, 0.5);
}

a:active {
  text-decoration: none;
}
</style>
